// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import router from './router'


//config
import http from './assets/lib/http.js'
import config from './assets/lib/config'

//css
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/style/style.scss';
//vuex
import store from './store/store.js'

//component
import { DatePicker, TimePicker,Button,MessageBox,Message } from 'element-ui'
import Loading from './components/loading'


Vue.use(Vuex);
Vue.use(http);
Vue.use(config);
Vue.use(DatePicker);
Vue.use(TimePicker);
Vue.use(Button);
Vue.component(MessageBox.name, MessageBox)
Vue.component(Message.name, Message)
Vue.component('loading', Loading)

Vue.prototype.$msgbox = MessageBox
Vue.prototype.$message = Message

Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm
Vue.config.productionTip = false;


import VueParticles from 'vue-particles'
Vue.use(VueParticles)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
});



// WEBPACK FOOTER //
// ./src/main.js